<template>
  <div class="eclub-quill-editor">
    <quill-editor ref="quillEditor" v-model="content" :options="editorOption" @ready="onEditorReady"/>
    <input ref="fileInput" type="file" accept="image/*" multiple style="display:none" @change="onFilesSelected" />
  </div>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css';
import '@/assets/style/quill.font.css';

import {quillEditor} from "vue-quill-editor";
import * as Quill from 'quill'

import ImageResize from 'quill-image-resize-module';
// import {ImageDrop} from 'quill-image-drop-module';

Quill.register('modules/imageResize', ImageResize);
// Quill.register('modules/imageDrop', ImageDrop);

let fonts = [false, 'arial', 'arial-black', 'georgia', 'impact', 'tahoma', 'times-new-roman', 'verdana', 'courier-new', 'lucida-console', 'monaco', 'monospace', 'malgun-gothic', 'gungsuh', 'dotum', 'gulim', 'batang']
let Font = Quill.import('formats/font')
Font.whitelist = fonts
Quill.register(Font, true)

let Size = Quill.import('attributors/style/size')
Size.whitelist = [false, '10px', '12px', '14px', '16px', '18px', '24px', '32px', '36px', '40px', '48px', '64px']
Quill.register(Size, true)

export default {
  name: "EditorQuillComponent",
  components: {
    quillEditor
  },
  props: {
    val:String
  },
  watch:{
    val: function(v) {
      this.content = v;
    },
  },
  data() {
    return {
      editorOption: {
        placeholder: '내용을 입력해주세요.',
        theme: 'snow',
        modules:{
          toolbar: [
            ['bold', 'italic', 'underline', 'strike', 'image', 'video', 'link'],
            ['formula', 'clean'],
            ['blockquote', 'code-block'],
            [{'list': 'ordered'}, {'list': 'bullet'}],
            [{'script': 'sub'}, {'script': 'super'}],
            // [{'size': ['small', false, 'large', 'huge']}],
            [{'size': Size.whitelist}],
            [{ 'font': fonts }],
            [{'header': [1, 2, 3, 4, 5, 6, false]}],
            [{ 'color': [] }, { 'background': [] }],
            [{ 'align': [] }],
            [{'direction': 'rtl'}],
            [{'indent': '-1'}, {'indent': '+1'}]
          ],
          imageResize:{
            displayStyles:{
              backgroundColor:'black',
              border:'none',
              color:'white'
            },
            modules:['Resize','DisplaySize']
            // modules:['Resize','DisplaySize','Toolbar']
          }
          // imageDrop: true
        }
      },
      content: ``,
    };
  },
  mounted() {
    // nothing here; quill instance is available via @ready
  },
  beforeDestroy() {
  },
  methods: {
    onEditorReady(quill) {
      this.quill = quill;
      try {
        const toolbar = this.quill.getModule('toolbar');
        if (toolbar) toolbar.addHandler('image', this.imageHandler);
      } catch (e) {
        // ignore
      }
    },
    imageHandler() {
      // open hidden file input to allow multiple selection
      this.$refs.fileInput && this.$refs.fileInput.click();
    },

    async onFilesSelected(e) {
      const files = Array.from(e.target.files || []);
      const MAX_FILES = 10;
      const allowed = files.slice(0, MAX_FILES).filter(f => f.type.startsWith('image/'));
      const concurrency = 3;
      const worker = async (file, insertIndex) => {
        try {
          const dataUrl = await this.resizeImage(file, 1600, 0.8);
          // insert at given index
          this.quill.insertEmbed(insertIndex, 'image', dataUrl);
        } catch (err) {
          console.error('image insert failed', err);
        }
      };

      // insert images sequentially but process resizing in limited concurrency
      let index = (this.quill.getSelection() || { index: this.quill.getLength() }).index;
      for (let i = 0; i < allowed.length; i += concurrency) {
        const batch = allowed.slice(i, i + concurrency).map((f, j) => worker(f, index + i + j));
        await Promise.all(batch);
      }
      // clear file input
      e.target.value = null;
    },

    resizeImage(file, maxWidth = 1600, quality = 0.8) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        const img = new Image();
        reader.onload = (ev) => { img.src = ev.target.result; };
        img.onload = () => {
          const canvas = document.createElement('canvas');
          const ratio = img.width > maxWidth ? maxWidth / img.width : 1;
          canvas.width = img.width * ratio;
          canvas.height = img.height * ratio;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
          try {
            const dataUrl = canvas.toDataURL('image/jpeg', quality);
            resolve(dataUrl);
          } catch (err) { reject(err); }
        };
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    },
    getValue() {
      return this.content;
    },
  },
};
</script>
<style>
.eclub-quill-editor .ql-editor{
  min-height:500px;
  max-height:500px;
}
.eclub-quill-editor .quill-container {
  height: auto;
  min-height: 100%;
  max-width: 90%;
  padding: 50px;
}
.eclub-quill-editor .quill-container .ql-editor {
  font-size: 18px;
  overflow-y: visible;
}

</style>